(function () {
  var MOBILE_MQ = '(max-width: 1023px)';

  /*
   * Scroll-linked dive into the hero video.
   * Linear progress (no easing) over a viewport-relative travel distance so
   * motion feels even as you scroll, with a strong scale so it reads as
   * moving into the frame rather than a slight Ken Burns nudge.
   */
  var DESKTOP_MAX_SCALE = 1.72;
  var MOBILE_MAX_SCALE = 1.50;
  /* Fraction of viewport height to fully complete the zoom */
  var DESKTOP_TRAVEL_VH = 1.1;
  var MOBILE_TRAVEL_VH = 0.9;

  function clamp01(value) {
    return value < 0 ? 0 : value > 1 ? 1 : value;
  }

  function initHeroVideo(video) {
    if (!video) return function () {};

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var syncPlayback = function () {
      if (reduceMotion.matches) {
        video.pause();
        video.currentTime = 0;
        return;
      }
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    };

    syncPlayback();
    reduceMotion.addEventListener('change', syncPlayback);
    return function () {
      reduceMotion.removeEventListener('change', syncPlayback);
    };
  }

  function initHeroScroll(media, bgWrap) {
    if (!media || !bgWrap) return function () {};

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMq = window.matchMedia(MOBILE_MQ);
    var frame = 0;
    var active = true;
    var lastZoom = '';
    /* Top of media at rest (accounts for fixed navbar offset) */
    var originTop = null;

    var syncOrigin = function () {
      if (window.scrollY <= 1) {
        originTop = media.getBoundingClientRect().top;
      }
    };

    var updateZoom = function () {
      frame = 0;
      if (!active) return;

      if (reduceMotion.matches) {
        if (lastZoom !== '') {
          bgWrap.style.removeProperty('--scroll-zoom');
          lastZoom = '';
        }
        return;
      }

      syncOrigin();
      if (originTop === null) originTop = media.getBoundingClientRect().top;

      var top = media.getBoundingClientRect().top;
      var isMobile = mobileMq.matches;
      var travel = Math.max(window.innerHeight * (isMobile ? MOBILE_TRAVEL_VH : DESKTOP_TRAVEL_VH), 1);
      var maxScale = isMobile ? MOBILE_MAX_SCALE : DESKTOP_MAX_SCALE;

      /*
       * Linear dive: measure how far the media has moved from its resting
       * position so zoom begins the moment scrolling starts (no dead zone).
       */
      var progress = clamp01((originTop - top) / travel);
      var nextZoom = (1 + progress * (maxScale - 1)).toFixed(4);

      if (nextZoom !== lastZoom) {
        bgWrap.style.setProperty('--scroll-zoom', nextZoom);
        lastZoom = nextZoom;
      }
    };

    var schedule = function () {
      if (!active || frame) return;
      frame = window.requestAnimationFrame(updateZoom);
    };

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          active = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (active) schedule();
        },
        { root: null, threshold: 0 },
      );
      observer.observe(media);
    }

    updateZoom();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    reduceMotion.addEventListener('change', updateZoom);
    mobileMq.addEventListener('change', updateZoom);

    return function () {
      active = false;
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      reduceMotion.removeEventListener('change', updateZoom);
      mobileMq.removeEventListener('change', updateZoom);
      if (observer) observer.disconnect();
      bgWrap.style.removeProperty('--scroll-zoom');
      lastZoom = '';
    };
  }

  function initSection(section) {
    if (!section || section.dataset.homeHeroReady === 'true') return;
    var media = section.querySelector('[data-home-hero-media]');
    var bgWrap = section.querySelector('[data-home-hero-bg-wrap]');
    var video = section.querySelector('[data-home-hero-video]');
    var cleanups = [initHeroVideo(video), initHeroScroll(media, bgWrap)].filter(Boolean);
    section.dataset.homeHeroReady = 'true';
    section._homeHeroCleanup = function () {
      cleanups.forEach(function (fn) {
        fn();
      });
      delete section.dataset.homeHeroReady;
      delete section._homeHeroCleanup;
    };
  }

  function destroySection(section) {
    if (section && typeof section._homeHeroCleanup === 'function') {
      section._homeHeroCleanup();
    }
  }

  function initAll() {
    document.querySelectorAll('.home-hero').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.home-hero') || (event.target.classList && event.target.classList.contains('home-hero') ? event.target : null)
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.home-hero') || (event.target.classList && event.target.classList.contains('home-hero') ? event.target : null)
      : null;
    if (section) destroySection(section);
  });
})();
